import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue-demi';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required,
  numeric,
  email,
  min,
  max,
  min_value,
  max_value,
  regex,
  oneOf,
} from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';
import { AbTitle, AbDescription, AbButton } from '../components/ui';
import FormFieldWrapper from './components/FormFieldWrapper.vue';
import StepsNavigation from './components/StepsNavigation.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import type { FormData, Field } from './types';
import { useFormValues } from './composables/useFormValues';
import { fieldComponents } from './mappings/fieldComponents';
import { getValidationRules, getValidationMessages } from './utils/validation';
import { DEFAULT_TEXTS } from './constants';
import FormFieldRecaptcha from './components/FormFieldRecaptcha.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormBuilder',
  props: {
    formData: null,
    isSubmitting: { type: Boolean },
    recaptchaConfig: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'submit', values: Record<string, any>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formData: FormData;
  isSubmitting?: boolean;
  recaptchaConfig?: {
    siteKey: string;
    theme?: string;
    size?: string;
  };
};

extend('required', required);
extend('numeric', numeric);
extend('email', email);
extend('min', min);
extend('max', max);
extend('min_value', min_value);
extend('max_value', max_value);
extend('regex', regex);
extend('oneOf', oneOf);

extend('required', {
  ...required,
  message: messages.required,
});

extend('numeric', {
  ...numeric,
  message: messages.numeric,
});

extend('email', {
  ...email,
  message: messages.email,
});

extend('min', {
  ...min,
  message: messages.min,
});

extend('max', {
  ...max,
  message: messages.max,
});

extend('min_value', {
  ...min_value,
  message: messages.min_value,
});

extend('max_value', {
  ...max_value,
  message: messages.max_value,
});

extend('regex', {
  ...regex,
  message: messages.regex,
});

extend('oneOf', {
  ...oneOf,
  message: messages.oneOf,
});





const observer = ref<InstanceType<typeof ValidationObserver> | null>(null);
const currentStepIndex = ref(0);
const currentStep = computed(
  () => props.formData.steps[currentStepIndex.value],
);

const { formValues } = useFormValues(props.formData);

const recaptchaError = ref<string | false>(false);

function onRecaptchaInput(val: string) {
  formValues.recaptcha = val;
  if (val) recaptchaError.value = false;
}

const setStep = (index: number) => {
  currentStepIndex.value = index;
};

const nextStep = async () => {
  if (observer.value) {
    const isValid = await observer.value.validate();
    if (isValid && currentStepIndex.value < props.formData.steps.length - 1) {
      currentStepIndex.value++;
    }
  }
};

const prevStep = () => {
  if (currentStepIndex.value > 0) {
    currentStepIndex.value--;
  }
};

const getFieldWidth = (field: Field) => {
  return field.type === 'hidden' ? undefined : field.width;
};

const onSubmit = async () => {
  if (observer.value) {
    const isValid = await observer.value.validate();
    if (
      props.recaptchaConfig &&
      currentStepIndex.value === props.formData.steps.length - 1 &&
      !formValues.recaptcha
    ) {
      recaptchaError.value = 'Пожалуйста, подтвердите, что вы не робот';
      return;
    }
    if (isValid) {
      emit('submit', { ...formValues });
    }
  }
};

return { __sfc: true,props, emit, observer, currentStepIndex, currentStep, formValues, recaptchaError, onRecaptchaInput, setStep, nextStep, prevStep, getFieldWidth, onSubmit, ValidationObserver, ValidationProvider, AbTitle, AbDescription, AbButton, FormFieldWrapper, StepsNavigation, ErrorMessage, fieldComponents, getValidationRules, getValidationMessages, DEFAULT_TEXTS, FormFieldRecaptcha }
}

})